import { render } from "./ShopConfigureComponent.vue?vue&type=template&id=067925c0&scoped=true"
import script from "./ShopConfigureComponent.vue?vue&type=script&lang=js"
export * from "./ShopConfigureComponent.vue?vue&type=script&lang=js"

import "./ShopConfigureComponent.vue?vue&type=style&index=0&id=067925c0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067925c0"]])

export default __exports__